export const GET_DASHBOARD = "GET_DASHBOARD";

export const GET_ANALYTIC = "GET_ANALYTIC";
